import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
  ViewEncapsulation,
} from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { Subscription } from 'rxjs';
import {
  ClaimSubmissionForms,
  MedicalCategory,
} from '../claim-submission.constant';
import {
  getDentalClaimLineInformation,
  getMedicalClaimLineInformation,
  updateDentalTreatment,
  updatePatientInformation,
  updateProviderInformation,
  updateServiceDetails,
} from '../claim-submission.helper';
import {
  ClaimLineContext,
  ClaimSubmission,
  DentalTreatmentContext,
  PatientInformationContext,
  ProviderInformationContext,
  ServiceDetailContext,
} from '../claim-submission.model';
import { ClaimSubmissionService } from '../claim-submission.service';
import {
  ClaimSubmissionDocumentData,
  SubmittedClaimDetails,
} from '../submittedClaim';

@Component({
  selector: 'zip-claim-submission-forms',
  templateUrl: './claim-submission-forms.component.html',
  styleUrls: ['./claim-submission-forms.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class ClaimSubmissionFormsComponent
  implements OnInit, AfterViewInit, OnDestroy
{
  @Input() config: ClaimSubmission;
  @Input() submittedClaimContext: SubmittedClaimDetails;
  @Output() formValueChanged: EventEmitter<UntypedFormGroup> =
    new EventEmitter<UntypedFormGroup>();
  patientInformationContext: PatientInformationContext;
  providerInformationContext: ProviderInformationContext;
  serviceDetailContext: ServiceDetailContext;
  dentalTreatmentContext: DentalTreatmentContext;
  claimLineContext: ClaimLineContext;
  supportingDocumentsContext: ClaimSubmissionDocumentData[];
  claimSubmitForm: UntypedFormGroup;
  formList;
  showServiceDetailAccidentalInjury: boolean;
  serviceDetails: string = ClaimSubmissionForms.serviceDetails;
  public subscription: Subscription = new Subscription();

  constructor(
    private cdref: ChangeDetectorRef,
    public claimSubmissionService: ClaimSubmissionService,
  ) {}

  ngOnInit(): void {
    if (this.submittedClaimContext) {
      this.setFormContext();
    }
    this.formList =
      this.config?.forms &&
      Object.entries(this.config?.forms).map(([key, value]) => ({
        key,
        value,
      }));
    this.populateClaimSubmissionForm();
    this.subscription.add(
      this.claimSubmitForm?.valueChanges.subscribe(() => {
        this.formValueChanged.emit(this.claimSubmitForm);
      }),
    );
  }

  ngAfterViewInit(): void {
    this.cdref.detectChanges();
    if (this.claimSubmissionService?.reviewSectionsId) {
      const id = this.claimSubmissionService.reviewSectionsId;

      document
        .getElementById(`${id}`)
        .scrollIntoView({ block: 'start', behavior: 'auto' });
    }
  }

  public setFormContext(): void {
    this.patientInformationContext = updatePatientInformation(
      this.submittedClaimContext,
      true,
    );
    this.providerInformationContext = updateProviderInformation(
      this.submittedClaimContext,
    );
    this.serviceDetailContext = updateServiceDetails(
      this.submittedClaimContext,
    );
    this.supportingDocumentsContext =
      this.submittedClaimContext.claimsubmissiondocument;

    if (
      this.submittedClaimContext.claimDetail.claimType ===
      MedicalCategory.medical
    ) {
      this.claimLineContext = getMedicalClaimLineInformation(
        this.submittedClaimContext,
      );
    } else {
      this.claimLineContext = getDentalClaimLineInformation(
        this.submittedClaimContext,
      );
      this.dentalTreatmentContext = updateDentalTreatment(
        this.submittedClaimContext,
      );
    }
  }

  public getDynamicFormGroups(formList: any): UntypedFormGroup {
    if (formList) {
      return new UntypedFormGroup(
        formList.reduce(
          (newGroup, formListItem) => ({
            [formListItem.key]: new UntypedFormGroup({}),
            ...newGroup,
          }),
          {},
        ),
      );
    }
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }

  private populateClaimSubmissionForm(): void {
    if (this.claimSubmissionService.hasReturnedFromReviewPage) {
      this.claimSubmitForm = this.claimSubmissionService.claimSubmitFormData;
    } else {
      this.claimSubmitForm = this.getDynamicFormGroups(this.formList);
    }
  }
}
